/* eslint-disable react/jsx-no-undef */
/* eslint-disable react/no-unescaped-entities */
/* eslint-disable @typescript-eslint/no-empty-function */
import {
  Box,
  FlexGrid,
  FlexGridItem,
  FormCheckBox,
  FormMaskedTextInput,
  FormRadioGroup,
  FormSection,
  FormTextInput,
  Heading,
  RadioButton,
  SubForm,
} from '@alinta-digital/asg';
import * as icon from '@alinta-digital/asg/icons/';
import useScript from '@alinta-digital/payment-form/components/CreditCard/utils';
import {
  BamboraCallbackResult,
  PaymentCardType,
} from '@alinta-digital/payment-form/types';
import { Field, FormikProps } from 'formik';
import React, { useEffect, useState } from 'react';
import { Element } from 'react-scroll';
import * as Yup from 'yup';
import { FormContainerContext } from '../../contexts/FormContainerContext';
import {
  pushAnalytics,
  resetFormContextError,
  scrollToScrollElement,
  setFormContextBranchDetails,
  setFormContextError,
} from '../../utils/utils';
import { config } from '../../config';
import { DirectDebitForm } from '../../views/Form/Form';
import { ErrorNotification } from '../ErrorNotification';
import DirectDebitCreditCard from './DirectDebitCreditCard';
import { ButtonV2, StyledLink, StyledText } from '../../Common.Styled';
import {
  analyticsLoaderSetup,
  analyticsLoaderStep3,
} from '../../utils/analytics.helper';
import { useLazyQuery } from '@apollo/client';
import {
  BsbValidateQueryRDTO,
  BsbValidateQueryDTO,
  BSB_VALIDATE_QUERY,
} from './validateBsb';
import { CustomCheckout } from '@alinta-digital/payment-form/view/PaymentDetails/PaymentDetails.types';
import { StripePaymentMethod } from '@alinta-digital/payment-form/components/Stripe/StripeCreditCard/StripeCreditCard';
import { useFeatureFlag } from '../../utils/useFeatureFlag';

interface DebitDetailsSubForm {
  paymentMethod: string;
  bankAccountName: string;
  bsbNumber: string;
  bankAccountNumber: string;
  accountConfirmation: boolean;
  collectDataConfirmation: boolean;
  invoiceConfirmation: boolean;
  cardName?: string;
  cardType?: PaymentCardType;
  creditCard?: {
    code: number;
    expiryMonth: string;
    expiryYear: string;
    last4: string;
    token: string;
  };
}

export interface DebitDetailsParentForm {
  debitDetails: DebitDetailsSubForm;
}

interface DebitDetailsProps {
  formikProps: FormikProps<DirectDebitForm>;
  isEdit: boolean;
  onPreviousClick: () => void;
  onNextClick: () => void;
}

// const guid =
//   config.bamboraUrl ===
//   'https://customcheckout.bambora.com.au/2.0.0/customcheckout.js'
//     ? '07b1d74a-fa7c-45dd-a340-d6350f7cc117'
//     : '89d71d3f-b006-4ebf-8936-b850e4faabc6';

// if (!guid) {
//   console.warn('Unable to resolve Bambora merchant id');
// }

interface BamboraCallbackResultExt extends BamboraCallbackResult {
  error?: Record<string, any>;
}

export const DebitDetailsSubFormCore: React.FC<DebitDetailsProps> = ({
  formikProps,
  onPreviousClick,
  onNextClick,
}) => {
  const LoaderIcon = icon.Loader;
  const {
    debitDetails: debitDetailParentValues,
    // eslint-disable-next-line
    identifyYourAccountForm: identifyYourAccountParentValues,
  } = formikProps.values;
  const {
    electricity: parentFormElectricity,
    gas: parentFormGas,
  } = formikProps.values.connection;

  const {
    values: formContextValues,
    dispatch: formContextDispatch,
  } = React.useContext(FormContainerContext);
  const {
    error: formContextError,
    bankBranch: formContextBankBranch,
  } = formContextValues;

  const [submitLoading, setSubmitLoading] = React.useState(false);
  const [loadingBsbField, setLoadingBsbField] = React.useState(false);
  const [typingBsbField, setTypingBsbField] = React.useState(false);
  const [paymentMethodData, setpaymentMethodData] = React.useState<
    StripePaymentMethod | undefined
  >(undefined);
  const [bankBranch, setBankBranch] = React.useState({
    valid: formContextBankBranch.valid,
    bsbNumber: formContextBankBranch.bsbNumber,
    displayName: formContextBankBranch.displayName,
    hideDisplayName: formContextBankBranch.hideDisplayName,
  });

  const [instance, setInstance] = useState<CustomCheckout | null>(null);
  const [isCardValid, setIsCardValid] = useState(false);
  const [paymentMethod, setPaymentMethod] = useState('');
  const { data: featureData } = useFeatureFlag('MyA_IsStripeEnabled');
  const isStripeEnabled = featureData?.featureValue;

  const [validateBSB] = useLazyQuery<BsbValidateQueryRDTO, BsbValidateQueryDTO>(
    BSB_VALIDATE_QUERY,
    {
      fetchPolicy: 'no-cache',
    }
  );

  React.useEffect(() => {
    if (paymentMethod === 'creditCard') {
      setInstance({
        on: () => {},
        create: () => ({
          mount: () => {},
        }),
        mount: () => {},
        createOneTimeToken: () => {},
      });
    }
    if (paymentMethod !== 'creditCard') {
      setInstance(null);
    }
  }, [paymentMethod]);

  React.useEffect(() => {
    if (formContextError.steps[2].status) {
      scrollToScrollElement('notificationError');
    } else {
      scrollToScrollElement('debitDetailsStart');
    }
  }, [formContextError.steps]);

  React.useEffect(() => {
    if (
      document.getElementById('debitDetails.bankAccountNumber') &&
      bankBranch.valid &&
      !loadingBsbField &&
      !typingBsbField
    )
      document.getElementById('debitDetails.bankAccountNumber')?.focus();
  }, [bankBranch.valid, loadingBsbField, typingBsbField]);

  React.useEffect(() => {
    pushAnalytics('load.0.dd.s3');
    analyticsLoaderStep3();
  }, []);

  useEffect(() => {
    analyticsLoaderSetup();
    if (paymentMethod === 'bankTransfer') {
      pushAnalytics('load.0.dd.s3.btd');
    }
    if (paymentMethod === 'creditCard') {
      pushAnalytics('load.0.dd.s3.ccd');
    }
  }, [paymentMethod]);
  return (
    <SubForm<DebitDetailsParentForm, DebitDetailsSubForm>
      formikProps={formikProps as any}
      valuesKey="debitDetails"
      config={{
        debitDetails: {
          paymentMethod: {
            validation: Yup.string().required('Please select a payment method'),
            initialValue: debitDetailParentValues.paymentMethod,
          },
          accountConfirmation: {
            validation: Yup.boolean().test(
              'validation',
              'Please read and agree',
              (value) => value
            ),
            initialValue: debitDetailParentValues.accountConfirmation,
          },
          collectDataConfirmation: {
            validation: Yup.boolean().test(
              'validation',
              'Please read and agree',
              (value) => value
            ),
            initialValue: debitDetailParentValues.collectDataConfirmation,
          },
          invoiceConfirmation: {
            validation: Yup.boolean().test(
              'validation',
              'Please read and agree',
              (value) => value
            ),
            initialValue: debitDetailParentValues.invoiceConfirmation,
          },
          bankAccountName: {
            validation: Yup.string().when('paymentMethod', {
              is: 'bankTransfer',
              then: Yup.string()
                .trim()
                .required('Please enter an account name.'),
              otherwise: Yup.string(),
            }),
            initialValue: debitDetailParentValues.bankAccountName,
          },
          bsbNumber: {
            validation: Yup.string().when('paymentMethod', {
              is: 'bankTransfer',
              then: Yup.string()
                .trim()
                .required('Please enter a valid BSB Number.')
                .min(7, 'Please enter a valid BSB Number.')
                .test(
                  'bsbNumber',
                  'Please enter a valid BSB Number.',
                  (bsbNumber: string) => {
                    if (
                      bankBranch.bsbNumber === bsbNumber &&
                      !bankBranch.valid
                    ) {
                      return false;
                    }

                    return true;
                  }
                ),
              otherwise: Yup.string(),
            }),
            initialValue: debitDetailParentValues.bsbNumber,
          },
          bankAccountNumber: {
            validation: Yup.string().when('paymentMethod', {
              is: 'bankTransfer',
              then: Yup.string()
                .required('Please enter your account number.')
                .min(6, 'Please enter a 6-9 digit account number.')
                .max(9, 'Please enter a 6-9 digit account number.'),
              otherwise: Yup.string(),
            }),
            initialValue: debitDetailParentValues.bankAccountNumber,
          },
          cardName: {
            validation: Yup.string().when('paymentMethod', {
              is: 'creditCard',
              then: Yup.string()
                .required('Please enter Name on card.')
                .max(100, 'A name must not exceed 100 characters.')
                .test({
                  name: 'name validation',
                  message:
                    'Please enter a name only containing letters. Hyphens and spaces may also be used between names.',
                  test: (name) => {
                    const nameValue = name || '';
                    const nameRegex = /^[a-zA-Z]+([-?\s?'?][a-zA-Z]+)*$/;
                    return nameRegex.test(nameValue);
                  },
                }),
            }),
            initialValue: debitDetailParentValues.cardName || '',
          },
        },
      }}
    >
      {({ validateSubForm, subFormFormikProps }) => {
        const { debitDetails: debitDetailValues } = subFormFormikProps.values;
        const { debitDetails: debitDetailErrors } = subFormFormikProps.errors;

        let allFieldsPopulated = true;
        const values: { [key: string]: string } = debitDetailValues;
        const keys: string[] = Object.keys(values);
        for (const key of keys) {
          if (
            key === 'cardName' &&
            debitDetailValues.paymentMethod !== 'creditCard'
          ) {
            continue;
          }
          allFieldsPopulated = !values[key].length ? false : true;
        }

        const isNextButtonDisabled =
          !allFieldsPopulated ||
          debitDetailErrors !== undefined ||
          (debitDetailValues.paymentMethod === 'bankTransfer' &&
            !bankBranch.valid) ||
          (debitDetailValues.paymentMethod === 'creditCard' && !isCardValid);

        return (
          <FormSection
            id="DebitDetails"
            heading="Step 3: Your debit details"
            stepNumber="3"
            totalSteps="4"
            previousButton={
              <ButtonV2
                id="debitDetailsPreviousButton"
                secondary={true}
                type="button"
                onClick={() => {
                  pushAnalytics('click.7.dd.s3.back');
                  resetFormContextError(
                    formContextValues,
                    formContextDispatch,
                    2
                  );
                  onPreviousClick();
                }}
              >
                Back
              </ButtonV2>
            }
            nextButton={
              <ButtonV2
                id="debitDetailsNextButton"
                disabled={isNextButtonDisabled}
                loading={submitLoading}
                primary={true}
                type="button"
                onClick={async () => {
                  pushAnalytics('click.8.dd.s3.next');
                  setSubmitLoading(true);
                  const { isValid } = await validateSubForm();

                  if (!isValid) {
                    setSubmitLoading(false);
                    return false;
                  }

                  formikProps.setValues({
                    ...formikProps.values,
                    ...subFormFormikProps.values,
                  });

                  if (debitDetailValues.paymentMethod === 'creditCard') {
                    try {
                      if (paymentMethodData && isStripeEnabled) {
                        formikProps.setValues({
                          ...formikProps.values,
                          ...subFormFormikProps.values,
                          debitDetails: {
                            ...debitDetailValues,
                            creditCard: {
                              token: paymentMethodData.id,
                              code:
                                paymentMethodData.card?.funding === 'credit'
                                  ? 1
                                  : 2,
                              expiryMonth: paymentMethodData.card?.exp_month.toString() as string,
                              expiryYear: paymentMethodData.card?.exp_year.toString() as string,
                              last4: paymentMethodData.card?.last4 || '',
                            },
                          },
                        });
                        onNextClick();
                      } else {
                        instance?.createOneTimeToken(
                          guid,
                          (result: BamboraCallbackResultExt) => {
                            if (result.token) {
                              formikProps.setValues({
                                ...formikProps.values,
                                ...subFormFormikProps.values,
                                debitDetails: {
                                  ...debitDetailValues,
                                  creditCard: result,
                                },
                              });

                              onNextClick();
                            } else {
                              console.error(result);
                              setSubmitLoading(false);
                              setFormContextError(
                                formContextValues,
                                formContextDispatch,
                                2,
                                true,
                                'Other'
                              );
                            }
                          }
                        );
                      }
                    } catch (e) {
                      setSubmitLoading(false);
                      setFormContextError(
                        formContextValues,
                        formContextDispatch,
                        2,
                        true,
                        'Other'
                      );
                    }
                  } else {
                    setSubmitLoading(false);
                    setFormContextBranchDetails(
                      formContextValues,
                      formContextDispatch,
                      bankBranch.valid,
                      bankBranch.bsbNumber,
                      bankBranch.displayName,
                      bankBranch.hideDisplayName
                    );

                    onNextClick();
                  }
                }}
              >
                Next
              </ButtonV2>
            }
          >
            {formContextError.steps[2].status ? (
              <ErrorNotification
                errorType={formContextError.steps[2].type}
                stateShortName={formContextValues.stateShortName}
                onClick={() =>
                  setFormContextError(
                    formContextValues,
                    formContextDispatch,
                    2,
                    false,
                    undefined
                  )
                }
              />
            ) : (
              <>
                <Element name="debitDetailsStart" id="debitDetailsStart" />
                <Box margin={{ bottom: '24px' }}>
                  <Heading level={3} color="#000F20" weight={700}>
                    How does Direct Debit work?
                  </Heading>
                  <Box margin={{ top: 'xsmall', bottom: '24px' }}>
                    <StyledText
                      lineHeight="28px"
                      style={{
                        fontWeight: 400,
                        fontSize: '18px',
                      }}
                    >
                      Direct debit is an automatic payment from your nominated
                      cheque, savings, transaction or credit card account. We’ll
                      debit the owed amount each time your bill’s due. You’ll
                      still receive a bill along with confirmation of your
                      payment.
                    </StyledText>
                  </Box>
                  <StyledText
                    lineHeight="28px"
                    style={{
                      fontWeight: 400,
                      fontSize: '18px',
                      marginBottom: '24px',
                    }}
                  >
                    To authorise direct debit, you agree:
                  </StyledText>
                  <Box margin={{ bottom: '24px' }}>
                    <Field
                      component={FormCheckBox}
                      name="debitDetails.accountConfirmation"
                      id="debitDetails.accountConfirmation"
                      data-testid="accountConfirmation"
                      label={
                        <StyledText
                          lineHeight="28px"
                          style={{
                            fontWeight: 400,
                            fontSize: '14px',
                          }}
                        >
                          I authorise Alinta Energy and its payment service
                          provider to direct debit my nominated bank account,
                          credit or debit card for any outstanding
                          amount/balance by the due date, until further notice,
                          as per the{' '}
                          <StyledLink
                            href="https://alintaenergy.com.au/directdebit-tcs"
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            residential
                          </StyledLink>
                          /
                          <StyledLink
                            href="https://www.alintaenergy.com.au/-/jssmedia/alinta-website/documents/sme/22-024-direct-debit-form-sme-online.pdf"
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            business
                          </StyledLink>{' '}
                          Direct Debit Service Agreement; and
                        </StyledText>
                      }
                    />
                  </Box>
                  <Box margin={{ bottom: '24px' }}>
                    <Field
                      component={FormCheckBox}
                      name="debitDetails.collectDataConfirmation"
                      id="debitDetails.collectDataConfirmation"
                      data-testid="collectDataConfirmation"
                      label={
                        <StyledText
                          lineHeight="28px"
                          style={{
                            fontWeight: 400,
                            fontSize: '14px',
                          }}
                        >
                          I am the account holder for the nominated payment
                          method, or am authorised by the account holder to set
                          up direct debit.
                        </StyledText>
                      }
                    />
                  </Box>
                  <Box>
                    <Field
                      component={FormCheckBox}
                      name="debitDetails.invoiceConfirmation"
                      id="debitDetails.invoiceConfirmation"
                      data-testid="invoiceConfirmation"
                      label={
                        <StyledText
                          lineHeight="28px"
                          style={{
                            fontWeight: 400,
                            fontSize: '14px',
                          }}
                        >
                          I acknowledge Alinta Energy collects my personal
                          information, and the personal information of any joint
                          account holder, in order to facilitate my direct debit
                          arrangement, or as described in Alinta Energy's{' '}
                          <StyledLink
                            href="https://www.alintaenergy.com.au/help-and-support/terms-and-conditions/myaccount-privacy-collection-notice"
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            Privacy Collection Notice
                          </StyledLink>{' '}
                          and{' '}
                          <StyledLink
                            href="https://www.alintaenergy.com.au/help-and-support/terms-and-conditions/privacy-policy"
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            Privacy Policy
                          </StyledLink>
                          .
                        </StyledText>
                      }
                    />
                  </Box>
                </Box>
                <Box>
                  <StyledText margin={{ bottom: '10px' }}>
                    Select bank account or credit card
                  </StyledText>
                  <Field
                    id="paymentMethod"
                    name="debitDetails.paymentMethod"
                    ariaRequired={true}
                    component={FormRadioGroup}
                  >
                    <Box direction="row" gap="medium">
                      <RadioButton
                        id={'paymentMethod-bankTransfer'}
                        data-testid="bankTransferRadioButton"
                        label="Bank transfer"
                        value="bankTransfer"
                        onClick={() => {
                          pushAnalytics('click.6.dd.s3.btb');
                          setPaymentMethod('bankTransfer');
                        }}
                      />
                      <RadioButton
                        id={'paymentMethod-creditCard'}
                        data-testid="creditCardRadioButton"
                        label="Credit card"
                        value="creditCard"
                        onClick={() => {
                          setPaymentMethod('creditCard');
                          pushAnalytics('click.5.dd.s3.ccb');

                          if (
                            parentFormElectricity.length > 1 ||
                            parentFormGas.length > 1
                          ) {
                            setFormContextError(
                              formContextValues,
                              formContextDispatch,
                              1,
                              true,
                              'Credit card limit'
                            );

                            onPreviousClick();
                          }
                        }}
                      />
                    </Box>
                  </Field>
                </Box>
                {debitDetailValues.paymentMethod === 'bankTransfer' && (
                  <Box>
                    <FlexGrid direction="row">
                      <FlexGridItem md={4}>
                        <Field
                          component={FormTextInput}
                          name="debitDetails.bankAccountName"
                          id="debitDetails.bankAccountName"
                          label="Account name"
                        />
                      </FlexGridItem>
                      <FlexGridItem md={4}>
                        <Field
                          width="100%"
                          component={FormMaskedTextInput}
                          name="debitDetails.bsbNumber"
                          id="debitDetails.bsbNumber"
                          label="BSB number"
                          options={{
                            blocks: [3, 3],
                            delimiter: '-',
                            numericOnly: true,
                          }}
                          disabled={
                            debitDetailValues.bankAccountName.length === 0 ||
                            loadingBsbField
                          }
                          inputIcon={
                            loadingBsbField ? (
                              <LoaderIcon id="bsbLoader" />
                            ) : (
                              undefined
                            )
                          }
                          message={
                            !bankBranch.hideDisplayName
                              ? bankBranch.displayName
                              : undefined
                          }
                          onChange={() => {
                            if (!typingBsbField) {
                              setTypingBsbField(true);
                            }

                            if (!bankBranch.hideDisplayName) {
                              setBankBranch({
                                ...bankBranch,
                                hideDisplayName: true,
                              });
                            }
                          }}
                          onBlur={async () => {
                            setTypingBsbField(false);
                            const bsbNumber = debitDetailValues.bsbNumber;

                            if (
                              debitDetailErrors &&
                              debitDetailErrors.bsbNumber !== undefined
                            ) {
                              return false;
                            }

                            if (bankBranch.bsbNumber !== bsbNumber) {
                              setLoadingBsbField(true);
                              try {
                                const result = await validateBSB({
                                  variables: {
                                    verifyBsbInput: { bsbNumber: bsbNumber },
                                  },
                                });
                                if (result.error) {
                                  throw new Error(result.error?.message ?? '');
                                }

                                setBankBranch({
                                  valid: true,
                                  bsbNumber: result.data?.validateBSB.bsb ?? '',
                                  displayName: `${result.data?.validateBSB.financialInstitutionCode}, ${result.data?.validateBSB.suburb}`,
                                  hideDisplayName: false,
                                });
                                setLoadingBsbField(false);
                              } catch (error) {
                                subFormFormikProps.setFieldError(
                                  'debitDetails.bsbNumber',
                                  'Please enter a valid BSB Number'
                                );
                                subFormFormikProps.setFieldTouched(
                                  'debitDetails.bsbNumber',
                                  true,
                                  false
                                );

                                setBankBranch({
                                  valid: false,
                                  bsbNumber: bsbNumber,
                                  displayName: '',
                                  hideDisplayName: true,
                                });
                                setLoadingBsbField(false);
                              }

                              return false;
                            } else if (
                              bankBranch.bsbNumber === bsbNumber &&
                              bankBranch.valid
                            ) {
                              setBankBranch({
                                ...bankBranch,
                                hideDisplayName: false,
                              });

                              return false;
                            }
                          }}
                        />
                      </FlexGridItem>
                      <FlexGridItem md={4}>
                        <Field
                          width="100%"
                          component={FormMaskedTextInput}
                          name="debitDetails.bankAccountNumber"
                          id="debitDetails.bankAccountNumber"
                          label="Account number"
                          type="tel"
                          options={{
                            numeral: true,
                            stripLeadingZeroes: false,
                            numeralThousandsGroupStyle: 'none',
                            numeralDecimalMark: 'none',
                            numeralPositiveOnly: true,
                          }}
                          disabled={
                            !bankBranch.valid ||
                            typingBsbField ||
                            loadingBsbField ||
                            (debitDetailErrors &&
                              debitDetailErrors.bsbNumber) ||
                            (debitDetailErrors &&
                              debitDetailErrors.bankAccountName)
                          }
                        />
                      </FlexGridItem>
                    </FlexGrid>
                  </Box>
                )}
                {debitDetailValues.paymentMethod === 'creditCard' && instance && (
                  <Box>
                    <FlexGrid direction="row">
                      <FlexGridItem>
                        <DirectDebitCreditCard
                          instance={instance}
                          loading={submitLoading}
                          setIsCardValid={setIsCardValid}
                          setPaymentMethod={(_dt: StripePaymentMethod) => {
                            setpaymentMethodData(_dt);
                          }}
                          isStripeEnabled={isStripeEnabled}
                        />
                      </FlexGridItem>
                    </FlexGrid>
                  </Box>
                )}
              </>
            )}
          </FormSection>
        );
      }}
    </SubForm>
  );
};

declare global {
  interface Window {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    customcheckout: any;
  }
}
